// td453 (Roger oct21 11:35 CST: "it does update the data of the client if it says some things are
// wrong"): a cita row may carry `datos_updates` -- the corrections the customer sent after the
// datos-confirmation message (WhatsApp reply or the voice readback), appended by the backend as
//   { field, label, old, new, decision: 'applied' | 'advisor_review', source, ts }
// `applied`        -> the cartera record was updated (old -> new);
// `advisor_review` -> a serie (VIN) correction: the record is NEVER changed from a reply, the advisor
//                     reviews it ("el cliente indica ...").
// Pure helpers shared by the Calendar detail panel and the Revisiones (advisor review) queue + card.
const FIELD_KEYS = {
  nombre: 'calendar.customer', telefono: 'calendar.phone', email: 'calendar.email',
  placas: 'calendar.plates', modelo: 'calendar.model', anio: 'calendar.year', vin: 'calendar.serie',
};
const FALLBACKS = {
  nombre: 'Nombre', telefono: 'Teléfono', email: 'Correo', placas: 'Placas', modelo: 'Modelo', anio: 'Año', vin: 'Serie',
};

const entriesOf = (row) => (row && Array.isArray(row.datos_updates) ? row.datos_updates : [])
  .filter((e) => e && typeof e === 'object' && typeof e.field === 'string' && e.field);

export const hasDatosUpdates = (row) => entriesOf(row).length > 0;

// [{ field, label, old, new, decision, source, ts }] in stored (chronological) order; unknown
// decisions are shown as advisor_review (never claimed as applied).
export const datosUpdatesEntries = (row) => entriesOf(row).map((e) => ({
  field: e.field,
  label: e.label || FALLBACKS[e.field] || e.field,
  old: e.old == null ? '' : String(e.old),
  new: e.new == null ? '' : String(e.new),
  decision: e.decision === 'applied' ? 'applied' : 'advisor_review',
  source: e.source === 'voice' ? 'voice' : 'whatsapp',
  ts: Number(e.ts) || 0,
}));

// "Datos corregidos por el cliente: Teléfono: +52 993 … → +52 993 …; Serie: el cliente indica
// …4321 (revisar)" ; '' when the row carries nothing. `tr(key, fallback)` resolves i18n safely.
export const formatDatosUpdates = (row, tr, { dash = '\u2014' } = {}) => {
  const t = typeof tr === 'function' ? tr : (_k, f) => f;
  const entries = datosUpdatesEntries(row);
  if (!entries.length) return '';
  const label = (e) => t(FIELD_KEYS[e.field] || '', e.label);
  const part = (e) => (e.decision === 'applied'
    ? `${label(e)}: ${e.old || dash} \u2192 ${e.new || dash}`
    : `${label(e)}: ${t('calendar.datosClientSays', 'el cliente indica')} ${e.new || dash} (${t('calendar.datosReview', 'revisar')})`);
  return `${t('calendar.datosUpdates', 'Datos corregidos por el cliente')}: ${entries.map(part).join('; ')}`;
};
